import { paths } from '../navigation/routes/paths';

// ===========================//
// =========== Pages =========//
// ===========================//

export const isOnFlow = (): boolean => {
    const { pathname } = window.location;
    return pathname.includes('home');
};

export const noTopBar = (): boolean => {
    const { pathname } = window.location;
    return pathname.includes('home') || pathname.includes(paths.homeTrackingMobile.replace(':id', ''));
};
